// noinspection JSUnusedGlobalSymbols
const amenities = {
  data: {
    'HAC-1':'a',
    'HAC-2':'b',
    'HAC-5':'c',
    'HAC-8':'d',
    'HAC-14':'e',
    'HAC-15':'f',
    'HAC-22':'g',
    'HAC-20':'\ue156' ,
    'HAC-26':'i',
    'HAC-35':'j',
    'HAC-36':'k',
    'HAC-37':'l',
    'HAC-42':'m',
    'HAC-46':'n',
    'HAC-48':'\ue164',
    'HAC-52':'o',
    'HAC-53':'\ue0cd',
    'HAC-54':'\ue13d',
    'HAC-58':'r',
    'HAC-61':'s',
    'HAC-65':'m',
    'HAC-66':'u',
    'HAC-68':'\ue925',
    'HAC-69':'\ue926',
    'HAC-70':'\ue928',
    'HAC-71':'\ue929',
    'HAC-72':'\ue92a',
    'HAC-73':'V',
    'HAC-74':'v',
    'HAC-75':'\ue073',
    'HAC-76':'t',
    'HAC-77':'w',
    'HAC-78':'\ue92f',
    'HAC-79':'x',
    'HAC-80':'\ue92e',
    'HAC-81':'\ue92d',
    'HAC-82':'\ue92c',
    'HAC-84':'y',
    'HAC-87':'\ue92b',
    'HAC-389':'\ue162',
    'HAC-88':'\ue162',
    'HAC-100': '\ue927',
    'HAC-105':'z',
    'HAC-145':'A',
    'HAC-157':'h',
    'HAC-159':'h',
    'HAC-403':'h',
    'HAC-179':'D',
    'HAC-224':'B',
    'HAC-227':'\ue901',
    'HAC-229':'\ue0ef',
    'HAC-269':'\ue050',
    'HAC-270': '\ue938',
    'HAC-283':'F',
    'HAC-284':'G',
    'HAC-316':'H',
    'HAC-317':'\ue159',
    'HAC-343':'\ue0b8',
    'HAC-344':'\ue0b8',
    'HAC-345':'\ue066',
    'HAC-346':'\ue066',
    'HAC-348':'N',
    'HAC-349':'\ue050',
    'HAC-350':'#',
    'HAC-351':'(',
    'HAC-353':'\ue06a',
    'HAC-370':'m',
    'HAC-371':'\ue130',
    'HAC-372':'\ue108',
    'HAC-373':'3',
    'HAC-375':'\ue0c1',
    'HAC-376':'\ue134',
    'HAC-378':'\ue907',
    'HAC-380':'\ue915',
    'HAC-381':'\ue136',
    'HAC-382':'\ue131',
    'HAC-383':'\ue031',
    'HAC-384':'\ue13b',
    'HAC-386':'Z',
    'HAC-387':'R',
    'HAC-391':'\ue0ef',
    'HAC-392':'\ue095',
    'HAC-393':'D',
    'HAC-394':'r',
    'HAC-395':'m',
    'HAC-396':'D',
    'HAC-397':'\ue0c3',
    'HAC-83':'\ue0c3',
    'HAC-398':'\ue128',
    'HAC-399':'\ue900',
    'HAC-400':'\ue91d',
    'HAC-401':'d',
    'HAC-402':'m',
    'HAC-404':'\ue90c',
    'HAC-406':'\ue906',
    // eslint-disable-next-line
    'HAC-407':'\N',
    'HAC-408':'\ue911',
    'HAC-409':'\ue910',
    'HAC-411':'&',
    'HAC-412':'\ue062',
    'HAC-413':'\ue90c',
    'HAC-414':'\ue11e',
    'HAC-415':'\ue90c',
    'HAC-416':'\ue0df',
    'HAC-417':'\ue07d',
    'HAC-418':'\ue917',
    'HAC-419':'r',
    'HAC-420':'\ue009',
    'HAC-421':'B',
    'HAC-whatsapp01HAC':'\ue075',
    'RMA-1':'a',
    'RMA-Nevera1RMA':'\ue109',
    'RMA-2':'c',
    'RMA-5':'c',
    'RMA-8':'d',
    'RMA-9':'Y',
    'RMA-10':'\ue931',
    'RMA-11':'0',
    'RMA-78':'0',
    'RMA-394':'0',
    'RMA-13':'1',
    'RMA-288':'\ue072',
    'RMA-14':'e',
    'RMA-15':'f',
    'RMA-18':'2',
    'RMA-19':'3',
    'RMA-20':'3',
    'RMA-22':'\ue15b',
    'RMA-26':'R',
    'RMA-28':'C',
    'RMA-35':'j',
    'RMA-36':'k',
    'RMA-37':'l',
    'RMA-42':'m',
    'RMA-46':'n',
    'RMA-48':'j',
    'RMA-50':'4',
    'RMA-52':'o',
    'RMA-53':'\ue939',
    'RMA-54':'3',
    'RMA-56':'O',
    'RMA-58':'r',
    'RMA-59':'\ue11f',
    'RMA-61':'V',
    'RMA-65':'m',
    'RMA-66':'u',
    'RMA-69':'5',
    'RMA-74':'v',
    'RMA-76':'t',
    'RMA-77':'w',
    'RMA-79':'\ue901',
    'RMA-80':'6',
    'RMA-84':'y',
    'RMA-91':'J',
    'RMA-92':'7',
    'RMA-101':'8',
    'RMA-105':'z',
    'RMA-107':'9',
    'RMA-112':'!',
    'RMA-113':'\ue034',
    'RMA-119':'"',
    'RMA-123':'D',
    'RMA-145':'A',
    'RMA-157':'h',
    'RMA-177':'\ue11d',
    'RMA-179':'D',
    'RMA-189':'h',
    'RMA-210':'#',
    'RMA-221':'v',
    'RMA-224':'B',
    'RMA-225':'\ue136',
    'RMA-227':'\ue901',
    'RMA-229':'L',
    'RMA-251':'S',
    'RMA-269':'k',
    'RMA-276':'%',
    'RMA-277':'x',
    'RMA-278':'\'',
    'RMA-281':'O',
    'RMA-282':'&',
    'RMA-283':'J',
    'RMA-284':'J',
    'RMA-285':'J',
    'RMA-286':'J',
    'RMA-287':'1',
    'RMA-316':'H',
    'RMA-317':'s',
    'RMA-343':'\ue0b8',
    'RMA-344':'\ue0b8',
    'RMA-345':'\ue066',
    'RMA-346':'\ue066',
    'RMA-349':'\ue050',
    'RMA-350':'#',
    'RMA-351':'(',
    'RMA-352':'(',
    'RMA-369':'\ue120',
    'RMA-370':'$',
    'RMA-371':'$',
    'RMA-372':'\ue161',
    'RMA-373':'\ue163',
    'RMA-374':'D',
    'RMA-375':'\ue15f',
    'RMA-376':'0',
    'RMA-377':'7',
    'RMA-378':'\ue900',
    'RMA-379':'\ue902',
    'RMA-441':'\ue902',
    'RMA-380':'\ue10b',
    'RMA-381':'\ue098',
    'RMA-382':'%',
    'RMA-383':'\ue031',
    'RMA-384':'\ue933',
    'RMA-385':'\ue932',
    'RMA-386':'\ue930',
    'RMA-387':'\ue10c',
    'RMA-388':'\ue15f',
    'RMA-389':'r',
    'RMA-390':'w',
    'RMA-391':'\ue907',
    'RMA-392':'Y',
    'RMA-393':'\ue098',
    'RMA-409':'\ue911',
    'RMA-410':'\ue910',
    'RMA-411':'\ue113',
    'RMA-412':'\ue919',
    'RMA-413':'\ue917',
    'RMA-414':'\ue90d',
    'RMA-415':'\ue163',
    'RMA-416':'\ue934',
    'RMA-417':'\ue912',
    'HAC-41':'\ue913',
    'HAC-85':'\ue913',
    'HAC-86':'\ue913',
    'RMA-418':'\ue913',
    'RMA-419':'1',
    'RMA-420':'3',
    'RMA-421':'\ue0d1',
    'RMA-422':'$',
    'RMA-440':'$',
    'RMA-423':'\ue916',
    'RMA-424':'\ue12e',
    'RMA-425':'\ue131',
    'RMA-426':'W',
    'RMA-428':'\ue0d6',
    'RMA-429':'\ue919',
    'RMA-430':'\ue91a',
    'RMA-431':'v',
    'RMA-432':'\ue13b',
    'RMA-433':'\ue91c',
    'RMA-434':'\ue108',
    'RMA-435':'\ue91b',
    'RMA-436':'\ue923',
    'RMA-437':'\ue13f',
    'RMA-438':'\ue927',
    'RMA-439':'\ue930',
    'RMA-442':'\ue098',
    'RMA-Handy1RMA':'\ue13e',
    'RMA-Cepillo1RMA':'\ue13f',
    'RMA-Cabello1RMA':'\ue140',
    'RMA-347': 'j',
    'RMA-348': 'u',
    'RMA-353': '\ue0c9',
    'RMA-354': '\ue157',
    'HAC-448': '\ue0cd',
    'RMA-448': '\ue0cd',
    'HAC-449': '0',
    'RMA-449': '0',
    'HAC-450': '\ue946',
    'RMA-450': '\ue946',
    'HAC-451': '\ue947',
    'RMA-451': '\ue947',
    'HAC-452': '\ue948',
    'RMA-452': '\ue948',
    'HAC-453': '\ue10c',
    'RMA-453': '\ue10c',
    'HAC-454': 'S',
    'RMA-454': 'S',
  },
  getter: {
    /**
     * Returns amenity by code
     * If code not found returns an empty string
     *
     * @param {string} code
     * @returns {string}
     */
    getAmenities(code) {
      return amenities.data[code] || '';
    }
  }
};

export default amenities;
